import { put, call, takeLatest } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";

import {
  GET_VIDEOS_REQUEST,
  getVideosSuccess,
  getVideosError,
} from "./actions";

import { logoutRequest } from "../../../login/actions";
import { Env } from "../../../../env";

function* getVideosRequest(action) {
  const { accessToken, playlistId } = action;
  let response;

  try {
    response = yield call(
      axios.get,
      `${Env.BASE_API_URL}/Playlists/${playlistId}/videos`,
      {
        headers: { Authorization: accessToken },
      }
    );
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(
        getVideosError("Une erreur s'est produite, veuillez réessayer.")
      );
      yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    }

    return;
  }

  yield put(getVideosSuccess(response.data));
}

export default function* watchGetVideosRequest() {
  yield takeLatest(GET_VIDEOS_REQUEST, getVideosRequest);
}



// WEBPACK FOOTER //
// ./src/pages/playlists/form/videos/saga.js